import React from "react";
import {Divider} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import CropDinIcon from '@material-ui/icons/CropDin';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    dialogContentRoot: {
        padding: 2
    }
}));

const PopoverWrapper = ({children, open, onClose, title, toggleFullScreen, apply}) => {
    const classes = useStyles();
    return (
        <Dialog
            open={Boolean(open)}
            onClose={onClose}
            fullWidth={true}
            maxWidth="lg"
            onEscapeKeyDown={e => e.stopPropagation()}
            disableEscapeKeyDown={true}
        >
            <div style={{padding: 5, display: 'flex'}}>
                <div style={{flexGrow: 1}}>
                    <Typography color={"textSecondary"}>
                        {title}
                    </Typography>
                </div>
                <Tooltip title={'Maximize'}>
                    <IconButton onClick={toggleFullScreen} size={"small"}>
                        <CropDinIcon style={{fontSize: '1rem'}}/>
                    </IconButton>
                </Tooltip>
                <Tooltip title={'Close'}>
                    <IconButton onClick={onClose} size={"small"}>
                        <CloseIcon style={{fontSize: '1rem'}}/>
                    </IconButton>
                </Tooltip>
            </div>
            <Divider/>
            <DialogContent style={{height: "90vh"}} classes={{root: classes.dialogContentRoot}}>
                {children}
            </DialogContent>
            <Divider/>
            <div style={{padding: 5, textAlign: "right"}}>
                <Button
                    size={"small"}
                    variant={"contained"}
                    color={"primary"}
                    onClick={() => {
                        apply();
                        onClose();
                    }}
                >
                    Apply
                </Button>
            </div>
        </Dialog>
    )
};
export default PopoverWrapper